import React, {Component} from 'react';

import Paging from '../../../Buttons/PagingBtn/index';
import PopupVocabUpload from '../../../Containers/PopupVocabUpload/index';
import * as AdminHomeworkService from '../../../../services/Teacher/AdminHomeworkService';

class AdminVocab extends Component {
	state = {
        popupVocabUploadShow: false,
        curPageVocabList: [],
        
        categoryGradeList: [],
        categorySectionList: [],
        categoryTitleList: [],

        // loading
        isLoadingHide: true
    }
	
	constructor() {
        super();
        this.curPage = 0;
        this.searchValue = null;
        this.sortSizeList = [
            {id: 0, text: "전체 보기", value: 1000000},
            {id: 1, text: "30개씩 보기", value: 30},
            {id: 2, text: "50개씩 보기", value: 50},
        ];
        this.sortSizeValue = 30;
        this.categoryGradeValue = null;
        this.categorySectionValue = null;
        this.categoryTitleValue = null;
        this.getVocabCategory('categoryGradeList');
    }
	componentDidMount = () => {
        this.getVocabList();
    }

    handleChange = (e) => {
	    this.curPage = 0;
	    this.sortSizeValue = e.target.value;
        this.getVocabList();
    }

    handleCategoryChange = (e) => {
    	const name = e.target.name;

    	this.curPage = 0;
        this.setState({
            [name]: e.target.value,
            categorySectionList : (name == 'categoryGradeValue')? [] : this.state.categorySectionList,
            categoryTitleList : (name == 'categoryGradeValue' || name == 'categorySectionValue')? [] : this.state.categoryTitleList,
        });
        if( name == 'categoryGradeValue' ) {
            this.categoryGradeValue = ( e.target.value == '대목차')? null : e.target.value;
            this.categorySectionValue = null;
            this.categoryTitleValue = null;
            if( this.categoryGradeValue == null ) {
                this.getVocabCategory('categoryGradeList');
            } else {
                this.getVocabCategory('categorySectionList', this.categoryGradeValue, this.categorySectionValue);
            }
        } else if( name == 'categorySectionValue' ) {
            this.categorySectionValue = ( e.target.value == '소목차')? null : e.target.value;
            this.categoryTitleValue = null;
            this.getVocabCategory('categoryTitleList', this.categoryGradeValue, this.categorySectionValue);
        } else {
            this.categoryTitleValue = ( e.target.value == '제목')? null : e.target.value;
            this.getVocabList();
        }
    }
        
    // 옵션 세팅
    setOptionSortSelectBox = () => {
        return (
            <div className="wrap-select">
                <span></span>
                <select name="sortSizeValue" value={this.sortSizeValue} onChange={this.handleChange}>
                    {this.sortSizeList.map((value, i) => {
                        return (
                            <option key={i} value={value.value}>{value.text}</option>
                        );
                    })}
                </select>
            </div>
        );
    }

    setOptionCategorySelectBox = (category) => {
	    return (
	            <div className="wrap-select">
	                <span></span>
	                <select name={[category]} onChange={this.handleCategoryChange}>
	                        {this.setOptionMappingValue(category)}
	                    </select>
	             </div>
	    );
    }
    
    setOptionMappingValue = (category) => {
	    const {categoryGradeList, categorySectionList, categoryTitleList} = this.state;
	    let result = null;
	        
	    if(category == 'categoryGradeValue')
	        result = categoryGradeList.map((grade, i) => { return <option key={i}>{grade}</option> });
	    else if(category == 'categorySectionValue')
	        result = categorySectionList.map((grade, i) => { return <option key={i}>{grade}</option> });
	    else
	        result = categoryTitleList.map((grade, i) => { return <option key={i}>{grade}</option> });
	
	    return result;
    }

    getVocabCategory = (category, grade, section) => {
        AdminHomeworkService.getVocabCategoryList(grade, section)
            .then((response) => {
                if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
                    let dataList = [];
                    dataList = response.data.data;
                    
                    let unshiftChar = (category  === 'categoryGradeList')? '대목차' : (category === 'categorySectionList')? '소목차' : '제목';                    
                    dataList.unshift(unshiftChar);
                    this.getVocabList();

                    this.setState({
                    categorySectionList: (category === 'categoryGradeList')? ['소목차'] : this.state.categorySectionList,
                    categoryTitleList: (category !== 'categoryTitleList')? ['제목'] : this.state.categoryTitleList,
                    [category]: dataList,
                    });
                }
            }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }


    getVocabList = () => {
        const pageVO = {
            page: this.curPage,
            size: this.sortSizeValue,
            direction: 'DESC',
            sortBy: 'vocabIndex'
        };
        
        if(this.categorySectionValue == '소제목') {
            this.categorySectionValue = null;
            this.categoryTitleValue = null;
        } else if(this.categoryTitleValue == '제목') {
            this.categoryTitleValue = null;
        }
        
        AdminHomeworkService.getVocabList(this.categoryGradeValue, this.categorySectionValue, this.categoryTitleValue, this.searchValue, pageVO).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.totalPages = responseData.data.totalPages;
                    this.totalElements = responseData.data.totalElements;
                    this.vocabList = responseData.data.content;
                    this.setState({
                        curPageVocabList: this.vocabList
                    });
                } else {
                    alert(responseData.data);
                }
            } else {
                console.log(response);
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert("SERVER ERROR");
        });
    }

    setPage = () => {
        const {curPageVocabList} = this.state;
        const list = curPageVocabList.map(
            (item, i) => (
                <tr key={i}>
                    <td>{(this.totalElements - this.curPage * this.sortSizeValue - i).toString()}</td>
                    {/*<td>{item.vocabIndex}</td>*/}
                    <td>{item.grade}</td>
                    <td>{item.section}</td>
                    <td>{item.title}</td>
                    <td>
                    	{
                    		(item.isViewMode == undefined || item.isViewMode)? item.english :
                    		<input className="ip-basic" type="text"
                    			name="classroomDuplicateNameCheck"
                    			onChange={(e) => this.onChangeVocab(i, 'English', e.target.value)}
                            	onKeyUp={this.enterKeyPress}
                    			placeholder={item.english}/>
                    	}
                	</td>
                    <td>
	                    {
	                    	(item.isViewMode == undefined || item.isViewMode)? item.korean :
	                		<input className="ip-basic" type="text"
	                			name="classroomDuplicateNameCheck"
	                			onChange={(e) => this.onChangeVocab(i, 'Korean', e.target.value)}
	                        	onKeyUp={this.enterKeyPress}
	                    		placeholder={item.korean}/>
	                	}
                    </td>
                    <td>
	                    {
	                    	(item.isViewMode == undefined || item.isViewMode)?
	                    		<a className="btn-sm deepPink" onClick={() => this.onEditMode(i)}>수정</a> :
	                    		<a className="btn-sm deepPink" onClick={() => this.onEditMode(i)}>확인</a>
	                    }
                    </td>
                </tr>
            )
        );
        return list;
    }
    
    onChangeVocab = (index, type, changeValue) => {
    	const {curPageVocabList} = this.state;
    	if(type == 'English') {
    		curPageVocabList[index].changeEnglish = changeValue;
    	} else {
    		curPageVocabList[index].changeKorean = changeValue;
    	}
    }

    onEditMode = (index) => {
    	const {curPageVocabList} = this.state;
    	if(curPageVocabList[index].isViewMode == undefined)
    		curPageVocabList[index].isViewMode = false;
    	else
    		curPageVocabList[index].isViewMode = !curPageVocabList[index].isViewMode;
    	
    	this.setState({curPageVocabList: curPageVocabList});
    	
    	const english = curPageVocabList[index].changeEnglish;
    	const korean = curPageVocabList[index].changeKorean;
    	if(english == null || english.trim() == '' || korean == null || korean.trim() == '') {
            return false;
        }
    	// api 연동
    	if(curPageVocabList[index].isViewMode)
    		this.updateVocabulary(curPageVocabList[index].id, (english == undefined)? curPageVocabList[index].english : english, (korean == undefined)? curPageVocabList[index].korean : korean);
    }
    
    updateVocabulary = (id, english, korean) => {
    	AdminHomeworkService.updateVocabulary(id, english, korean)
	        .then((response) => {
	            if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
	                this.getVocabList();
	            }
	        }).catch((error) => {
	        console.log(error);
	        alert('SERVER ERROR');
	    });
    }
    
    showVocabUploadPopup = () => {
        this.setState({
            popupVocabUploadShow: true
        });
    }

    // input 데이터 저장
    onInputValueChanged = (e) => {
	    if(e.target.value == '')
	        this.inputValue = null;
        this.inputValue = e.target.value
    }

    //단어로 검색
    onSearch = () => {
	    this.curPage = 0;
	    this.searchValue = this.inputValue;
	    this.getVocabList();
    }

    onSubmit = (arr) => {
        this.setState({popupVocabUploadShow: false});
        this.getVocabList();
        this.getVocabCategory('categoryGradeList');
    }
    
    onUpdatePage = (page) => {
    	console.log("onUpdatePage: "+page);
    	this.curPage = page;
    	this.getVocabList();
    }
	
	render() {
		const { popupVocabUploadShow } = this.state;
		return (
			<div className="wrap-rCon">
				<PopupVocabUpload active={popupVocabUploadShow} onSubmit={this.onSubmit} />
		        <div className="wrap-top">
		            <a className="baseBtn undefined blue" onClick={this.showVocabUploadPopup}><span>단어 저장하기</span></a>
		            <div className="box-rfix">
		
		                {this.setOptionSortSelectBox()}
		                {this.setOptionCategorySelectBox('categoryGradeValue')}
		                {this.setOptionCategorySelectBox('categorySectionValue')}
		                {this.setOptionCategorySelectBox('categoryTitleValue')}
		
		                <div className="wrap-search">
		                    <input className="ip-basic" type="text" placeholder="영어단어 검색"
		                           onChange={this.onInputValueChanged}/>
		                    <a className="btn-sm yellow" onClick={() => this.onSearch()}>검색</a>
		                </div>
		            </div>
		        </div>
		
		        <div className="tb-scroll">
		            <table className="tb-basic">
		                <colgroup>
		                    <col width="10%"/>
		                    <col width="15%"/>
		                    <col width="15%"/>
		                    <col width="15%"/>
		                    <col width="15%"/>
		                	<col width="20%"/>
		                </colgroup>
		                <thead>
		                <tr>
		                    <th>번호</th>
		                    <th>대목차</th>
		                    <th>소목차</th>
		                    <th>제목</th>
		                    <th>영문</th>
		                    <th>국문</th>
		                    <th>수정</th>
		                </tr>
		                </thead>
		                <tbody>
		                {this.setPage()}
		                </tbody>
		            </table>
		        </div>
		        <Paging currentPage={this.curPage} totalPages={this.totalPages} onUpdatePage={this.onUpdatePage} />
		    </div>
		);	
	}
}

export default AdminVocab;


// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminSystem/AdminVocab.js